export const SET_FLEET = (data) => {
  return {
    type: "SET_FLEET",
    payload: data,
  };
};

export const VIEW_DEVICES = (data) => {
  return {
    type: "VIEW_DEVICES",
    payload: data,
  };
};
export const ADD_NEW_DEVICES = (data) => {
  return {
    type: "ADD_NEW_DEVICES",
    payload: data,
  };
};
export const WHITELIST_DEVICES = (data) => {
  return {
    type: "WHITELIST_DEVICES",
    payload: data,
  };
};
export const BLACKLIST_DEVICES = (data) => {
  return {
    type: "BLACKLIST_DEVICES",
    payload: data,
  };
};
